import { render, staticRenderFns } from "./codeTable.vue?vue&type=template&id=5190e9cf&"
import script from "./codeTable.vue?vue&type=script&lang=js&"
export * from "./codeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports